import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-323c64b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_invoice",
  ref: "createInvoiceModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-1200px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y m-5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = { class: "pb-10 pb-lg-15" }
const _hoisted_11 = { class: "fw-bolder d-flex align-items-center text-dark" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Billing is issued based on your selected Invoice type"
}, null, -1))
const _hoisted_13 = { class: "fv-row" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-4" }
const _hoisted_16 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_fast"
}
const _hoisted_17 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_18 = { class: "d-block fw-bold text-start" }
const _hoisted_19 = { class: "text-dark fw-bolder d-block fs-4 mb-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "If you need more info, please check it out", -1))
const _hoisted_21 = { class: "col-lg-4" }
const _hoisted_22 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_medium"
}
const _hoisted_23 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_24 = { class: "d-block fw-bold text-start" }
const _hoisted_25 = { class: "text-dark fw-bolder d-block fs-4 mb-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "If you need more info, please check it out", -1))
const _hoisted_27 = { class: "col-lg-4" }
const _hoisted_28 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "kt_create_account_form_account_type_full"
}
const _hoisted_29 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_30 = { class: "d-block fw-bold text-start" }
const _hoisted_31 = { class: "text-dark fw-bolder d-block fs-4 mb-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Create corporate account to mane users", -1))
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "w-100" }
const _hoisted_35 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_36 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_37 = { class: "flex-lg-row-fluid mb-10 mb-lg-0 me-lg-7 me-xl-10" }
const _hoisted_38 = { class: "card" }
const _hoisted_39 = { class: "card-body p-12" }
const _hoisted_40 = { class: "d-flex flex-column align-items-start flex-xxl-row" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "fs-6 fw-bolder text-gray-700 text-nowrap" }
const _hoisted_43 = { class: "position-relative d-flex align-items-center" }
const _hoisted_44 = ["title"]
const _hoisted_45 = { class: "fs-2x fw-bolder text-gray-800" }
const _hoisted_46 = ["title"]
const _hoisted_47 = { class: "fs-6 fw-bolder text-gray-700 text-nowrap" }
const _hoisted_48 = { class: "position-relative d-flex align-items-center w-150px" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-10" }, null, -1))
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = {
  key: 0,
  class: "row gx-10 mb-5"
}
const _hoisted_52 = { class: "col-lg-6" }
const _hoisted_53 = { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }
const _hoisted_54 = { class: "mb-5" }
const _hoisted_55 = { class: "mb-5" }
const _hoisted_56 = { class: "col-lg-6" }
const _hoisted_57 = { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }
const _hoisted_58 = { class: "mb-5" }
const _hoisted_59 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_60 = {
  type: "button",
  class: "btn btn-link py-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_create_account"
}
const _hoisted_61 = { class: "table-responsive mb-10" }
const _hoisted_62 = { class: "table g-5 gs-0 mb-0 fw-bolder text-gray-700" }
const _hoisted_63 = { class: "border-bottom fs-7 fw-bolder text-gray-700 text-uppercase" }
const _hoisted_64 = { class: "min-w-300px w-475px" }
const _hoisted_65 = { class: "min-w-100px w-100px" }
const _hoisted_66 = { class: "min-w-150px w-150px" }
const _hoisted_67 = { class: "min-w-100px w-150px text-end" }
const _hoisted_68 = { class: "min-w-75px w-75px text-end" }
const _hoisted_69 = { class: "pe-7" }
const _hoisted_70 = { class: "ps-0" }
const _hoisted_71 = { class: "pt-8 text-end text-nowrap" }
const _hoisted_72 = { "data-kt-element": "total" }
const _hoisted_73 = { class: "pt-5 text-end" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.5",
      d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.5",
      d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = { class: "border-top border-top-dashed align-top fw-bolder text-gray-500" }
const _hoisted_78 = { class: "text-primary" }
const _hoisted_79 = {
  colspan: "4",
  class: "border-bottom border-bottom-dashed ps-0"
}
const _hoisted_80 = { class: "d-flex align-items-start" }
const _hoisted_81 = { class: "mb-0 me-5" }
const _hoisted_82 = { class: "mb-0 w-150px" }
const _hoisted_83 = { class: "align-top fw-bolder text-gray-500" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_85 = {
  colspan: "2",
  class: "border-bottom border-bottom-dashed ps-0"
}
const _hoisted_86 = { class: "d-flex flex-column align-items-start" }
const _hoisted_87 = {
  colspan: "2",
  class: "border-bottom border-bottom-dashed text-end"
}
const _hoisted_88 = { class: "align-top fw-bolder text-gray-500" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_90 = {
  colspan: "2",
  class: "ps-0"
}
const _hoisted_91 = {
  colspan: "2",
  class: "border-bottom border-bottom-dashed text-end"
}
const _hoisted_92 = { class: "align-top fw-bolder text-gray-500" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_94 = {
  colspan: "2",
  class: "ps-0"
}
const _hoisted_95 = {
  colspan: "2",
  class: "border-bottom border-bottom-dashed text-end"
}
const _hoisted_96 = { class: "align-top fw-bolder text-gray-700" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_98 = {
  colspan: "2",
  class: "fs-4 ps-0"
}
const _hoisted_99 = {
  colspan: "2",
  class: "text-end fs-4 text-nowrap"
}
const _hoisted_100 = { "data-kt-element": "grand-total" }
const _hoisted_101 = {
  class: "table d-none",
  "data-kt-element": "empty-template"
}
const _hoisted_102 = { "data-kt-element": "empty" }
const _hoisted_103 = {
  colspan: "5",
  class: "text-muted text-center py-10"
}
const _hoisted_104 = { class: "flex-lg-auto min-w-lg-300px" }
const _hoisted_105 = {
  class: "card",
  "data-kt-sticky": "true",
  "data-kt-sticky-name": "invoice",
  "data-kt-sticky-offset": "{default: false, lg: '200px'}",
  "data-kt-sticky-width": "{lg: '250px', lg: '300px'}",
  "data-kt-sticky-left": "auto",
  "data-kt-sticky-top": "150px",
  "data-kt-sticky-animation": "false",
  "data-kt-sticky-zindex": "95"
}
const _hoisted_106 = { class: "card-body p-10" }
const _hoisted_107 = { class: "mb-8" }
const _hoisted_108 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack mb-5" }
const _hoisted_109 = { class: "form-check-label ms-0 fw-bolder fs-6 text-gray-700" }
const _hoisted_110 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack" }
const _hoisted_111 = { class: "form-check-label ms-0 fw-bolder fs-6 text-gray-700" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mt-8 mb-8" }, null, -1))
const _hoisted_113 = { class: "mb-6 fv-row w-100" }
const _hoisted_114 = { class: "d-flex align-items-center form-label mb-5" }
const _hoisted_115 = { class: "mb-0" }
const _hoisted_116 = { class: "d-flex align-items-center me-2" }
const _hoisted_117 = { class: "d-flex flex-column" }
const _hoisted_118 = { class: "fw-bolder text-gray-800 text-hover-primary" }
const _hoisted_119 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_120 = ["value"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mt-8 mb-8" }, null, -1))
const _hoisted_122 = { class: "mb-6 fv-row w-100" }
const _hoisted_123 = { class: "d-flex align-items-center form-label mb-5" }
const _hoisted_124 = { class: "mb-0" }
const _hoisted_125 = { class: "d-flex align-items-center me-2" }
const _hoisted_126 = { class: "d-flex flex-column" }
const _hoisted_127 = { class: "fw-bolder text-gray-800 text-hover-primary" }
const _hoisted_128 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_129 = ["value"]
const _hoisted_130 = {
  key: 0,
  class: "separator separator-dashed mt-8 mb-8"
}
const _hoisted_131 = {
  key: 1,
  class: "mb-6 fv-row w-100"
}
const _hoisted_132 = { class: "d-flex align-items-center form-label mb-5" }
const _hoisted_133 = { class: "mb-0" }
const _hoisted_134 = { class: "d-flex align-items-center me-2" }
const _hoisted_135 = { class: "symbol symbol-50px me-6" }
const _hoisted_136 = { class: "symbol-label" }
const _hoisted_137 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_138 = ["src"]
const _hoisted_139 = { class: "d-flex flex-column" }
const _hoisted_140 = { class: "fw-bolder text-gray-800 text-hover-primary" }
const _hoisted_141 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_142 = ["value"]
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-8" }, null, -1))
const _hoisted_144 = { key: 2 }
const _hoisted_145 = ["placeholder"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mt-8 mb-8" }, null, -1))
const _hoisted_147 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_148 = { class: "form-label fs-6 fw-bolder text-gray-700" }
const _hoisted_149 = ["placeholder"]
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mt-8 mb-8" }, null, -1))
const _hoisted_151 = { class: "mb-0" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.43 8.56949L10.744 15.1395C10.6422 15.282 10.5804 15.4492 10.5651 15.6236C10.5498 15.7981 10.5815 15.9734 10.657 16.1315L13.194 21.4425C13.2737 21.6097 13.3991 21.751 13.5557 21.8499C13.7123 21.9488 13.8938 22.0014 14.079 22.0015H14.117C14.3087 21.9941 14.4941 21.9307 14.6502 21.8191C14.8062 21.7075 14.9261 21.5526 14.995 21.3735L21.933 3.33649C22.0011 3.15918 22.0164 2.96594 21.977 2.78013C21.9376 2.59432 21.8452 2.4239 21.711 2.28949L15.43 8.56949Z",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M20.664 2.06648L2.62602 9.00148C2.44768 9.07085 2.29348 9.19082 2.1824 9.34663C2.07131 9.50244 2.00818 9.68731 2.00074 9.87853C1.99331 10.0697 2.04189 10.259 2.14054 10.4229C2.23919 10.5869 2.38359 10.7185 2.55601 10.8015L7.86601 13.3365C8.02383 13.4126 8.19925 13.4448 8.37382 13.4297C8.54839 13.4145 8.71565 13.3526 8.85801 13.2505L15.43 8.56548L21.711 2.28448C21.5762 2.15096 21.4055 2.05932 21.2198 2.02064C21.034 1.98196 20.8409 1.99788 20.664 2.06648Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_153 = { class: "indicator-label" }
const _hoisted_154 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_155 = { class: "indicator-progress" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_157 = { class: "d-flex flex-stack pt-15" }
const _hoisted_158 = { class: "me-2" }
const _hoisted_159 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_160 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("create_invoice")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              class: "mx-auto w-100 py-10",
              novalidate: "novalidate",
              ref: "createInvoiceRef",
              model: _ctx.formData,
              onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.createInvoice()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                (_ctx.currentStepIndex === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h2", _hoisted_11, [
                            _createTextVNode(_toDisplayString(_ctx.$t("chooseInvoiceType")) + " ", 1),
                            _hoisted_12
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                class: "btn-check",
                                name: "type",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.type) = $event)),
                                value: "simple",
                                id: "kt_create_account_form_account_type_fast"
                              }, null, 512), [
                                [_vModelRadio, _ctx.formData.type]
                              ]),
                              _createElementVNode("label", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com005.svg" })
                                ]),
                                _createElementVNode("span", _hoisted_18, [
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("fastInvoice")), 1),
                                  _hoisted_20
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                class: "btn-check",
                                name: "type",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.type) = $event)),
                                value: "medium",
                                id: "kt_create_account_form_account_type_medium"
                              }, null, 512), [
                                [_vModelRadio, _ctx.formData.type]
                              ]),
                              _createElementVNode("label", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com005.svg" })
                                ]),
                                _createElementVNode("span", _hoisted_24, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("mediumInvoice")), 1),
                                  _hoisted_26
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                class: "btn-check",
                                name: "type",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.type) = $event)),
                                value: "full",
                                id: "kt_create_account_form_account_type_full"
                              }, null, 512), [
                                [_vModelRadio, _ctx.formData.type]
                              ]),
                              _createElementVNode("label", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/finance/fin006.svg" })
                                ]),
                                _createElementVNode("span", _hoisted_30, [
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("fullInvoice")), 1),
                                  _hoisted_32
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentStepIndex === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("div", {
                                      class: "d-flex align-items-center flex-equal fw-row me-4 order-2 gap-3",
                                      "data-bs-toggle": "tooltip",
                                      "data-bs-trigger": "hover",
                                      title: _ctx.$t('specifyInvoiceDate')
                                    }, [
                                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("date")) + ": ", 1),
                                      _createElementVNode("div", _hoisted_43, [
                                        _createVNode(_component_el_form_item, {
                                          prop: "release_date",
                                          class: "mb-0",
                                          rules: [
                                      {
                                        required: true,
                                        message: _ctx.$t('release_date_is_required'),
                                      },
                                    ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              class: "form-control-transparent pe-5 w-150px",
                                              name: "release_date",
                                              format: "YYYY/MM/DD",
                                              "value-format": "YYYY-MM-DD",
                                              placeholder: _ctx.$t('selectDate'),
                                              modelValue: _ctx.formData.release_date,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.release_date) = $event))
                                            }, null, 8, ["placeholder", "modelValue"])
                                          ]),
                                          _: 1
                                        }, 8, ["rules"])
                                      ])
                                    ], 8, _hoisted_41),
                                    _createElementVNode("div", {
                                      class: "d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4",
                                      "data-bs-toggle": "tooltip",
                                      "data-bs-trigger": "hover",
                                      title: _ctx.$t('enterInvoiceNumber')
                                    }, [
                                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("invoice")) + " #", 1),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control form-control-flush fw-bolder text-muted fs-3 w-125px",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.rand_number) = $event)),
                                        placehoder: "..."
                                      }, null, 512), [
                                        [_vModelText, _ctx.formData.rand_number]
                                      ])
                                    ], 8, _hoisted_44),
                                    _createElementVNode("div", {
                                      class: "d-flex align-items-center justify-content-end flex-equal order-3 gap-3 fw-row",
                                      "data-bs-toggle": "tooltip",
                                      "data-bs-trigger": "hover",
                                      title: _ctx.$t('specifyInvoiceDueDate')
                                    }, [
                                      _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("dueDate")) + ": ", 1),
                                      _createElementVNode("div", _hoisted_48, [
                                        _createVNode(_component_el_form_item, {
                                          prop: "due_date",
                                          class: "mb-0",
                                          rules: [
                                      {
                                        required: true,
                                        message: _ctx.$t('due_date_is_required'),
                                      },
                                      {
                                        validator: (rule, value, callback) => {
                                          if (value) {
                                            if (
                                              _ctx.moment(value).isBefore(
                                                _ctx.moment(_ctx.formData.release_date)
                                              )
                                            ) {
                                              callback(
                                                _ctx.$t(
                                                  'due_date_must_be_after_release_date'
                                                )
                                              );
                                            } else {
                                              callback();
                                            }
                                          } else {
                                            callback();
                                          }
                                        },
                                      },
                                    ]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              type: "text",
                                              class: "form-control-transparent pe-5 w-150px",
                                              name: "due_date",
                                              placeholder: _ctx.$t('selectDate'),
                                              modelValue: _ctx.formData.due_date,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.due_date) = $event)),
                                              format: "YYYY/MM/DD",
                                              "value-format": "YYYY-MM-DD"
                                            }, null, 8, ["placeholder", "modelValue"])
                                          ]),
                                          _: 1
                                        }, 8, ["rules"])
                                      ])
                                    ], 8, _hoisted_46)
                                  ]),
                                  _hoisted_49,
                                  _createElementVNode("div", _hoisted_50, [
                                    (_ctx.formData.type != 'simple')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                          _createElementVNode("div", _hoisted_52, [
                                            _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("billFrom")), 1),
                                            _createElementVNode("div", _hoisted_54, [
                                              _createVNode(_component_el_input, {
                                                type: "text",
                                                value: _ctx.user.market_name,
                                                disabled: "",
                                                placeholder: _ctx.$t('name')
                                              }, null, 8, ["value", "placeholder"])
                                            ]),
                                            _createElementVNode("div", _hoisted_55, [
                                              _createVNode(_component_el_input, {
                                                type: "text",
                                                value: _ctx.user.market_email,
                                                disabled: "",
                                                placeholder: _ctx.$t('email')
                                              }, null, 8, ["value", "placeholder"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_56, [
                                            _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("billTo")), 1),
                                            _createElementVNode("div", _hoisted_58, [
                                              _createVNode(_component_el_form_item, {
                                                prop: "customer_id",
                                                rules: [
                                        {
                                          required:
                                            _ctx.formData.type !== 'simple'
                                              ? true
                                              : false,
                                          message: _ctx.$t('customer_is_required'),
                                          trigger: 'change',
                                        },
                                      ]
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.formData.customer_id,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                                                    placeholder: _ctx.$t('select_customer'),
                                                    class: "w-100",
                                                    size: "large"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters
                                            .Customers, (customer) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: customer.id,
                                                          label: customer.name,
                                                          value: customer.id
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue", "placeholder"])
                                                ]),
                                                _: 1
                                              }, 8, ["rules"])
                                            ]),
                                            (_ctx.formData.type == 'full')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                  _createElementVNode("button", _hoisted_60, _toDisplayString(_ctx.$t("addNewCustomer")), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("table", _hoisted_62, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_63, [
                                            _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.$t("item")), 1),
                                            _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.$t("quantity")), 1),
                                            _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.$t("price")), 1),
                                            _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.$t("total")), 1),
                                            _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.$t("action")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.products, (item, index) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              class: "border-bottom border-bottom-dashed",
                                              key: index
                                            }, [
                                              _createElementVNode("td", _hoisted_69, [
                                                _createVNode(_component_el_form_item, {
                                                  prop: `products.${index}.product_name`,
                                                  rules: [
                                            {
                                              required: true,
                                              message: _ctx.$t(
                                                'product_name_is_required'
                                              ),
                                              trigger: 'change',
                                            },
                                          ]
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                      placeholder: _ctx.$t('itemName'),
                                                      modelValue: item.product_name,
                                                      "onUpdate:modelValue": ($event: any) => ((item.product_name) = $event)
                                                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["prop", "rules"]),
                                                _createVNode(_component_el_form_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                      placeholder: _ctx.$t('description'),
                                                      modelValue: item.product_desc,
                                                      "onUpdate:modelValue": ($event: any) => ((item.product_desc) = $event)
                                                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _createElementVNode("td", _hoisted_70, [
                                                _createVNode(_component_el_form_item, {
                                                  prop: `products.${index}.product_quantity`,
                                                  rules: [
                                            {
                                              required: true,
                                              message: _ctx.$t(
                                                'product_quantity_is_required'
                                              ),
                                              trigger: 'change',
                                            },
                                          ]
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                      type: "number",
                                                      placeholder: "1",
                                                      minlength: "1",
                                                      modelValue: item.product_quantity,
                                                      "onUpdate:modelValue": ($event: any) => ((item.product_quantity) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["prop", "rules"])
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createVNode(_component_el_form_item, {
                                                  prop: `products.${index}.product_price`,
                                                  rules: [
                                            {
                                              required: true,
                                              message: _ctx.$t(
                                                'product_price_is_required'
                                              ),
                                              trigger: 'change',
                                            },
                                          ]
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_input, {
                                                      type: "number",
                                                      placeholder: "0.00",
                                                      minlength: "1",
                                                      modelValue: item.product_price,
                                                      "onUpdate:modelValue": ($event: any) => ((item.product_price) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["prop", "rules"])
                                              ]),
                                              _createElementVNode("td", _hoisted_71, [
                                                _createTextVNode(_toDisplayString(_ctx.$store.state.currency) + " ", 1),
                                                _createElementVNode("span", _hoisted_72, _toDisplayString(item.product_quantity &&
                                            item.product_price
                                              ? (
                                                  item.product_quantity *
                                                  item.product_price
                                                ).toFixed(2)
                                              : "0.00"), 1)
                                              ]),
                                              _createElementVNode("td", _hoisted_73, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn btn-sm btn-icon btn-active-color-primary",
                                                  "data-kt-element": "remove-item",
                                                  onClick: _withModifiers(($event: any) => (_ctx.removeItem(index)), ["prevent"])
                                                }, _hoisted_76, 8, _hoisted_74)
                                              ])
                                            ]))
                                          }), 128))
                                        ]),
                                        _createElementVNode("tfoot", null, [
                                          _createElementVNode("tr", _hoisted_77, [
                                            _createElementVNode("th", _hoisted_78, [
                                              _createElementVNode("button", {
                                                class: "btn btn-link py-1",
                                                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)), ["prevent"]))
                                              }, _toDisplayString(_ctx.$t("addItem")), 1)
                                            ]),
                                            _createElementVNode("th", _hoisted_79, [
                                              _createElementVNode("div", _hoisted_80, [
                                                _createElementVNode("div", _hoisted_81, [
                                                  _createVNode(_component_el_form_item, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_input, {
                                                        type: "number",
                                                        placeholder: 
                                                  _ctx.$t('discount_amount')
                                                ,
                                                        minlength: "1",
                                                        modelValue: 
                                                  _ctx.formData.discount_amount
                                                ,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((
                                                  _ctx.formData.discount_amount
                                                ) = $event))
                                                      }, null, 8, ["placeholder", "modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_82, [
                                                  _createVNode(_component_el_form_item, { prop: "discount_type" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_select, {
                                                        modelValue: _ctx.formData.discount_type,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.discount_type) = $event)),
                                                        class: "w-100",
                                                        size: "large"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_el_option, {
                                                            value: "percentage",
                                                            label: _ctx.$t('percentage')
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.$t("percentage")), 1)
                                                            ]),
                                                            _: 1
                                                          }, 8, ["label"]),
                                                          _createVNode(_component_el_option, {
                                                            value: "fixed",
                                                            label: _ctx.$t('fixed')
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.$t("fixed")), 1)
                                                            ]),
                                                            _: 1
                                                          }, 8, ["label"])
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("tr", _hoisted_83, [
                                            _hoisted_84,
                                            _createElementVNode("th", _hoisted_85, [
                                              _createElementVNode("div", _hoisted_86, [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$t("subTotal")), 1)
                                              ])
                                            ]),
                                            _createElementVNode("th", _hoisted_87, [
                                              _createTextVNode(_toDisplayString(_ctx.$store.state.currency) + " ", 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.totalInvoice.toFixed(2)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("tr", _hoisted_88, [
                                            _hoisted_89,
                                            _createElementVNode("th", _hoisted_90, _toDisplayString(_ctx.$t("discount")), 1),
                                            _createElementVNode("th", _hoisted_91, [
                                              _createTextVNode(_toDisplayString(_ctx.$store.state.currency) + " ", 1),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formData.discount_amount
                                              ? parseFloat(
                                                  _ctx.formData.discount_amount
                                                ).toFixed(2)
                                              : "0.00"), 1)
                                            ])
                                          ]),
                                          _createElementVNode("tr", _hoisted_92, [
                                            _hoisted_93,
                                            _createElementVNode("th", _hoisted_94, _toDisplayString(_ctx.$t("tax")), 1),
                                            _createElementVNode("th", _hoisted_95, [
                                              _createTextVNode(_toDisplayString(_ctx.$store.state.currency) + " ", 1),
                                              _createElementVNode("span", null, _toDisplayString((
                                              (_ctx.formData.invoice_tax / 100) *
                                              _ctx.totalInvoice
                                            ).toFixed(2)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("tr", _hoisted_96, [
                                            _hoisted_97,
                                            _createElementVNode("th", _hoisted_98, _toDisplayString(_ctx.$t("total")), 1),
                                            _createElementVNode("th", _hoisted_99, [
                                              _createTextVNode(_toDisplayString(_ctx.$store.state.currency) + " ", 1),
                                              _createElementVNode("span", _hoisted_100, _toDisplayString((
                                              _ctx.totalInvoice +
                                              (_ctx.formData.invoice_tax / 100) *
                                                _ctx.totalInvoice -
                                              _ctx.formData.discount_amount
                                            ).toFixed(2)), 1)
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("table", _hoisted_101, [
                                      _createElementVNode("tr", _hoisted_102, [
                                        _createElementVNode("th", _hoisted_103, _toDisplayString(_ctx.$t("noItems")), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _createElementVNode("label", _hoisted_108, [
                                      _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$t("paidInvoice")), 1),
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.paidInvoice) = $event))
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.paidInvoice]
                                      ])
                                    ]),
                                    _createElementVNode("label", _hoisted_110, [
                                      _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.$t("notes")), 1),
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.toggleNotes) = $event))
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.toggleNotes]
                                      ])
                                    ])
                                  ]),
                                  _hoisted_112,
                                  _createElementVNode("div", _hoisted_113, [
                                    _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t("selectShippingCompany")), 1),
                                    _createElementVNode("div", _hoisted_115, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.shipping_companies, (company, i) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                          class: "d-flex flex-stack mb-5 cursor-pointer",
                                          key: i
                                        }, [
                                          _createElementVNode("span", _hoisted_116, [
                                            _createElementVNode("span", _hoisted_117, [
                                              _createElementVNode("span", _hoisted_118, _toDisplayString(company.name), 1)
                                            ])
                                          ]),
                                          _createElementVNode("span", _hoisted_119, [
                                            _withDirectives(_createElementVNode("input", {
                                              class: "form-check-input",
                                              type: "radio",
                                              name: "shipping_company_id",
                                              value: company.id,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.shipping_company_id) = $event))
                                            }, null, 8, _hoisted_120), [
                                              [_vModelRadio, _ctx.formData.shipping_company_id]
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _hoisted_121,
                                  _createElementVNode("div", _hoisted_122, [
                                    _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t("selectMethodType")), 1),
                                    _createElementVNode("div", _hoisted_124, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.payment_methods, (payment, i) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                          class: "d-flex flex-stack mb-5 cursor-pointer",
                                          key: i
                                        }, [
                                          _createElementVNode("span", _hoisted_125, [
                                            _createElementVNode("span", _hoisted_126, [
                                              _createElementVNode("span", _hoisted_127, _toDisplayString(payment.name), 1)
                                            ])
                                          ]),
                                          _createElementVNode("span", _hoisted_128, [
                                            _withDirectives(_createElementVNode("input", {
                                              class: "form-check-input",
                                              type: "radio",
                                              name: "payment_id",
                                              value: payment.id,
                                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.payment_id) = $event))
                                            }, null, 8, _hoisted_129), [
                                              [_vModelRadio, _ctx.formData.payment_id]
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  (_ctx.formData.payment_id == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_130))
                                    : _createCommentVNode("", true),
                                  (_ctx.formData.payment_id == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                        _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t("selectBankType")), 1),
                                        _createElementVNode("div", _hoisted_133, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.accounts, (bank, i) => {
                                            return (_openBlock(), _createElementBlock("label", {
                                              class: "d-flex flex-stack mb-5 cursor-pointer",
                                              key: i
                                            }, [
                                              _createElementVNode("span", _hoisted_134, [
                                                _createElementVNode("span", _hoisted_135, [
                                                  _createElementVNode("span", _hoisted_136, [
                                                    _createElementVNode("span", _hoisted_137, [
                                                      _createElementVNode("img", {
                                                        class: "img-fluid",
                                                        src: bank.bank_image
                                                      }, null, 8, _hoisted_138)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("span", _hoisted_139, [
                                                  _createElementVNode("span", _hoisted_140, _toDisplayString(bank.account_name), 1)
                                                ])
                                              ]),
                                              _createElementVNode("span", _hoisted_141, [
                                                _withDirectives(_createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "radio",
                                                  name: "bank_id",
                                                  value: bank.id,
                                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.account_id) = $event))
                                                }, null, 8, _hoisted_142), [
                                                  [_vModelRadio, _ctx.formData.account_id]
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_143,
                                  (_ctx.paymentMethod)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control form-control-solid mb-2",
                                          placeholder: _ctx.$t('paymentUrl'),
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.paymentUrl) = $event))
                                        }, null, 8, _hoisted_145), [
                                          [_vModelText, _ctx.paymentUrl]
                                        ]),
                                        _hoisted_146
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.toggleNotes)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                        _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.$t("notes")), 1),
                                        _createElementVNode("textarea", {
                                          name: "notes",
                                          class: "form-control form-control-solid",
                                          rows: "3",
                                          placeholder: _ctx.$t('yourNotesHere')
                                        }, null, 8, _hoisted_149),
                                        _hoisted_150
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("button", {
                                      class: "btn btn-primary w-100",
                                      id: "kt_invoice_submit_button",
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.formSubmit()))
                                    }, [
                                      _hoisted_152,
                                      _createElementVNode("span", _hoisted_153, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("sendInvoice")) + " ", 1),
                                        _createElementVNode("span", _hoisted_154, [
                                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                        ])
                                      ]),
                                      _createElementVNode("span", _hoisted_155, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
                                        _hoisted_156
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_157, [
                  _createElementVNode("div", _hoisted_158, [
                    (_ctx.currentStepIndex === 2)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-lg btn-light-primary me-3",
                          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.currentStepIndex = 1), ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_159, [
                            _createVNode(_component_inline_svg, {
                              src: `/media/icons/duotune/arrows/arr06${
                          _ctx.il8n.locale.value == 'ar' ? '4' : '3'
                        }.svg`
                            }, null, 8, ["src"])
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("back")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.currentStepIndex === 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.currentStepIndex = 2), ["prevent"])),
                          class: "btn btn-lg btn-primary"
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t("continue")) + " ", 1),
                          _createElementVNode("span", _hoisted_160, [
                            _createVNode(_component_inline_svg, {
                              src: `/media/icons/duotune/arrows/arr06${
                          _ctx.il8n.locale.value == 'ar' ? '3' : '4'
                        }.svg`
                            }, null, 8, ["src"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ])
  ], 512))
}